<template>
    <b-modal
      no-close-on-backdrop
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      ok-only
      size="lg"
      ok-title="Fechar"
      ok-variant="danger"
      v-model="open"
      title="Produtos por Categoria"
      :busy="loading"
    >
      <b-row v-if="loading">
        <b-col cols="12" class="text-center">
          <b-spinner label="Spinning"></b-spinner>
        </b-col>
      </b-row>

      <b-row v-else class="mt-2">
        <b-col>
          <span class="font-weight-bold fs-22 ml-2">{{ item.name }}</span>
        </b-col>

        <b-col cols="12 mt-4">
          <b-table
            striped
            hover
            responsive
            :fields="table.headers"
            :items="table.records"
            :busy="loading"
          >

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Carregando...</strong>
            </div>
          </template>

          <template #cell(photo)="data">
            <img :src="linkFotos(data.item.origem) + data.item.menu_product_photos[0].foto_png" :alt="data.item.produto" class="imgWidth"/>
          </template>

          <template #cell(product)="data">
            <span class="spanProduct">
              {{ data.item.nome_extra && data.item.nome_extra != null ? data.item.nome_extra : data.item.produto }}
            </span>
          </template>

          <template #cell(marca)="data">
            <span class="spanProduct">
              {{  
                data.item.marca_extra && data.item.marca_extra != null ?
                data.item.marca_extra : data.item.marca
              }}
            </span>
          </template>

          </b-table>
        </b-col>
      </b-row>
    </b-modal>
  </template>
  
  <script>
  import { mapActions, mapState } from 'vuex';
  
  import makeToast from '@/mixins/makeToast';
  
  export default {
    name: 'modalProductsCategoryApp',
    mixins: [makeToast],

    data() {
      return {
        loading: false,
        item: [],
        open: false,
        table:{
          headers: [
            {
              key: 'index',
              thClass: 'd-none',
              tdClass: 'd-none',
            },
            {
            key: 'productId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'photo',
            label: 'Foto',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'product',
            label: 'Produto',
            sortable: true,
          },
          {
            key: 'marca',
            label: 'Marca',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
            sortable: true,
          },
          ],
          records:[]
        },
      };
    },
    computed: {
      ...mapState(['dadosUsuario']),
    },
    methods: {
      ...mapActions('shopkeeper', ['getProductCategory']),

      toggleOpen({ item = [] }) {
        this.open = !this.open;
        this.item = item;
        this.get();
      },

      get() {
        if (this.loading || !this.item) return;
  
        this.loading = true;

        const data = {
          id:this.item.id,
          lojistaId: this.dadosUsuario.id
        }
  
        this.getProductCategory(data)
          .then((response) => {
            this.table.records = response.data.data || {};
          })
          .catch(() => {
            this.makeToast(
              'Erro',
              'Houve um erro ao trazer os dados do pedido',
              'danger'
            );
          })
          .finally(() => {
            this.loading = false;
          });
      },
      linkFotos(origem) {
        if(origem == 'Belenus' || origem == 'fixadores') {
          return 'https://storage.googleapis.com/fotos-prd/';
        } else {
          return process.env.VUE_APP_FOTOS_URL;
        }
      },
    },
  };
  </script>

  <style scoped>
  .imgWidth {
    width: 50px;
  }
  </style>